const PageType = {
  Site: "SITE",
  JobDescription: "JOB_DESCRIPTION"
};

export { PageType };
//# sourceMappingURL=page-type.mjs.map
